import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import conf from "../config";
import config from "../config";

class StaffStore {
  staff = [];
  vehicleList = [];
  total = 0;
  loading = false;
  photoFromDb = {};
  rootStore;
  constructor(rootStore) {
    makeObservable(this, {
      vehicleList: observable,
      staff: observable,
      total: observable,
      loading: observable,
      photoFromDb: observable,
      loadData: action,
      getStaffData: action,
      addData: action,
      deleteRecord: action,
      setPhotoFromDb: action,
      getVehicleNo: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, salesPersonName, isadmin }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      salesPersonName: salesPersonName,
      offset: offset,
      limit: limit,
      page: 1,
      isadmin: isadmin,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=salesperson&a=getPersonsDetails",
    //     "postData=" + base64Input
    //   );

    var queryParams = {
      companyId: companyId,
      salesPersonName: salesPersonName,
      offset: offset,
      limit: limit,
      page: 1,
      isadmin: isadmin,
    };

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/employee/getPersonsDetails", {
        params: queryParams,
      });

    this.staff = response?.data?.data?.SalesPersonsData;

    this.loading = false;
  }

  // async addData(staff) {
  //   var postData = { tokenId: "80bovn8u800tg1aq9bvr73kbhh", person: staff };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=salesperson&a=update", "postData=" + base64Input);
  //   return response.data;
  // }

  async addData(staff) {
    var postData = { person: staff };
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/employee/createOrUpdate", postData);
    return response.data;
  }

  async setPhotoFromDb(photo) {
    this.photoFromDb = { fileList: photo };
  }
  async getStaffData(staffId) {
    var postData = { sid: staffId, offset: 0, limit: 1 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=salesperson&a=getPersonsDetails",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/employee/getPersonsDetails", {
        params: postData,
      });
    const singleRow = response.data.data.SalesPersonsData[0];

    if (singleRow.photo) {
      const fileList = [
        {
          name: singleRow.photo,
          status: "success",
          url: conf.fleetURL + "/images/salesperson/" + singleRow.photo,
        },
      ];

      await this.setPhotoFromDb(fileList);
    }
    return singleRow;
  }

  // async deleteRecord({ id }) {
  //   const postData = { id: id };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=salesperson&a=delete", "postData=" + base64Input);
  //   return response;
  // }

  async deleteRecord({ id }) {
    var response = await postApi
      .getClient("")
      .delete(`https://dolphin.trackeazy.com/api/employee/delete/${id}`);
    // .delete(config.NodeUrl + "/employee/delete?&id=" + id);
    return response;
  }

  // async getEmployeeType() {
  //   var postData = null;
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=salesperson&a=getEmployeeType",
  //       "postData=" + base64Input
  //     );
  //   return response?.data?.data;
  // }

  async getEmployeeType() {
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/employee/employee-types");
    return response?.data?.data;
  }

  // async getDepartment() {
  //   var postData = null;
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=salesperson&a=getDepartment",
  //       "postData=" + base64Input
  //     );
  //   return response?.data?.data;
  // }

  async getDepartment() {
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/department/getDepartment");
    return response?.data?.data;
  }

  // async addDepartment(departmentDetails) {
  //   var postData = departmentDetails;
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=salesperson&a=addDepartment",
  //       "postData=" + base64Input
  //     );
  //   return response?.data?.data;
  // }

  async addDepartment(departmentDetails) {
    var postData = departmentDetails;
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/department/addDepartment", {
        postData,
      });
    return response?.data?.data;
  }

  async getVehicleNo(companyId) {
    var postData = {
      companyId: companyId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

    this.vehicleList = response?.data?.data;
    return response?.data?.data;
  }
}

export default StaffStore;
